import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {
    OnlineChatAiNoulActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {OnlineChatAiNoulParamInterface} from "~/cabinet/vue/client/events/action/types/Interface";


const __default__ = {
    name: "OnlineChatAiNoulBlockForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<OnlineChatAiNoulActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let _modelValue = _useModel<getActionDescriptionModelType<OnlineChatAiNoulActionDescription>>(__props, "modelValue");
let model = useObjectModel<OnlineChatAiNoulParamInterface>(_modelValue, () => {
    return {
        subject: "",
        instructions: ""
    }
});

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Текст для анализа"
    }, {
      default: _withCtx(() => [
        _createVNode(TextInputWithVariables, {
          modelValue: _unref(model).subject,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).subject) = $event)),
          "content-variables": _unref(props).contentVariables,
          multiline: false
        }, null, 8, ["modelValue", "content-variables"])
      ]),
      _: 1
    }, 8, ["rules"]),
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Вопрос для нейро-сети"
    }, {
      default: _withCtx(() => [
        _createVNode(TextInputWithVariables, {
          modelValue: _unref(model).instructions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).instructions) = $event)),
          "content-variables": _unref(props).contentVariables,
          multiline: false
        }, null, 8, ["modelValue", "content-variables"])
      ]),
      _: 1
    }, 8, ["rules"])
  ]))
}
}

})